export default "__VITE_ASSET__82c3daac__"